import * as React from "react";
import moment from "moment";
import styled from "styled-components";
import { Table as BaseTable } from "components/bootstrap";
import Badge from "components/bootstrap/Badge";
import { Icon } from "components/common";
import Routes from "routing/Routes";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
const Table = styled(BaseTable)`
  margin: 0;
`;
const ShrinkCell = styled.td`
  width: 1%;
  white-space: nowrap;
`;
const StatusBadge = styled(Badge)`
  min-width: max-content;
`;
const StyledIcon = styled(Icon)`
  color: ${({ theme, $disabled }) => $disabled ? theme.colors.text.disabled : theme.colors.text.primary};
`;
const Title = styled.span`
  color: ${({ theme, $disabled }) => $disabled ? theme.colors.text.disabled : theme.colors.text.primary};
`;
const TitleLink = styled.a`
  color: ${({ theme }) => theme.colors.global.link};

  &:hover {
    text-decoration: underline;
  }
`;
const LastSeen = styled.small`
  color: ${({ theme, $disabled }) => $disabled ? theme.colors.text.disabled : theme.colors.text.primary};
`;
const lastSeenLabel = (rule) => {
  if (rule.seen && rule.last_seen_at) {
    return `last seen ${moment(rule.last_seen_at).fromNow()}`;
  }
  return "not seen in detection window";
};
const RuleTitle = ({ rule }) => {
  const { permissions } = useCurrentUser();
  if (rule.db_id && isPermitted(permissions, `eventdefinitions:read:${rule.db_id}`)) {
    return /* @__PURE__ */ React.createElement(TitleLink, { href: Routes.ALERTS.DEFINITIONS.show(rule.db_id), target: "_blank", rel: "noopener noreferrer" }, rule.title);
  }
  return /* @__PURE__ */ React.createElement(Title, { $disabled: !rule.seen }, rule.title);
};
const DetectionChainRulesList = ({
  chainRules
}) => /* @__PURE__ */ React.createElement(Table, { condensed: true, hover: false }, /* @__PURE__ */ React.createElement("tbody", null, (chainRules != null ? chainRules : []).map((rule) => /* @__PURE__ */ React.createElement("tr", { key: rule.id }, /* @__PURE__ */ React.createElement(ShrinkCell, null, /* @__PURE__ */ React.createElement(StyledIcon, { name: rule.seen ? "task" : "scan_delete", size: "sm", $disabled: !rule.seen })), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(RuleTitle, { rule })), /* @__PURE__ */ React.createElement(ShrinkCell, null, /* @__PURE__ */ React.createElement(StatusBadge, { bsStyle: rule.enabled ? "success" : "default", bsSize: "sm" }, rule.enabled ? "enabled" : "disabled")), /* @__PURE__ */ React.createElement(ShrinkCell, null, /* @__PURE__ */ React.createElement(LastSeen, { $disabled: !rule.seen }, lastSeenLabel(rule)))))));
export default DetectionChainRulesList;
